shadow$provide[436] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform vec4 reverseScale;
uniform vec4 reverseOffset;

vec4 getReverseOffset(vec4 xyzw) {
  return xyzw * reverseScale + reverseOffset;
}`;

};